export default "__VITE_ASSET__C8nhm0uf__"